module.exports = __webpack_public_path__ + "img/logo-main-mobile.74db2c28.svg";